import { useCallback } from "react";
import { useDropzone } from "react-dropzone";
import IconButton from "@mui/material/IconButton";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import { useTranslation } from "i18n";

const DragAndDrop = ({ file, getFile, label }) => {
  const { t } = useTranslation();

  const onDrop = useCallback(
    (acceptedFiles) => {
      const nextFile = acceptedFiles?.[0];
      if (nextFile) getFile(nextFile);
    },
    [getFile],
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    multiple: false,
  });

  return (
    <div className="job-upload">
      <p className="job-upload__label">
        <span>*</span> {label}
      </p>

      {!file?.name ? (
        <div
          {...getRootProps()}
          className={`job-upload__drop${isDragActive ? " is-active" : ""}`}
        >
          <input {...getInputProps()} />
          <CloudUploadIcon />
          <p>
            {isDragActive
              ? t("jobs.dropFileActive")
              : t("jobs.dropFileHint")}
          </p>
        </div>
      ) : (
        <div className="job-upload__file">
          <CheckCircleRoundedIcon />
          <p title={file.name}>{file.name}</p>
          <IconButton
            onClick={() => getFile(null)}
            aria-label={t("jobs.removeFile")}
            size="small"
          >
            <HighlightOffIcon color="error" />
          </IconButton>
        </div>
      )}
    </div>
  );
};

export default DragAndDrop;
